/**
 * Переводы для InPost (страница успеха «Twoja płatność się powiodła» и index2).
 * По country_code. Fallback: PL.
 */
const BASE_PL = {
  loading: 'Ładowanie...',
  tagline: 'out of the box',
  navPickup: 'Odbieram',
  navSend: 'Wysyłam',
  navForBusiness: 'Dla Firm',
  navAbout: 'O InPost',
  navForFan: 'Dla Kibica',
  navPricing: 'Cennik',
  navContact: 'Kontakt',
  navShop: 'Zakupy',
  trackParcel: 'Śledź paczkę',
  findPaczkomat: 'Znajdź Paczkomat®',
  paymentSuccessTitle: 'Twoja płatność się powiodła',
  deliveryInfo: 'Informacje o dostawie',
  buyerNameLabel: 'Imię i nazwisko kupującego',
  deliveryAddressLabel: 'Adres dostawy',
  deliveryAddressPlaceholder: '—',
  infoBoxText: 'Jak tylko środki zostaną zaksięgowane na Twoim koncie, wyślij towar do nabywcy zgodnie z danymi',
  nextBtn: 'Dalej',
  captchaTitle: 'Zweryfikuj, że jesteś człowiekiem',
  captchaSubtitle: 'Szybka kontrola…',
  notRobot: 'Nie jestem robotem',
  continue: 'Kontynuuj',
  captchaFooter: 'Napędzane przez XCaptcha • Bezpieczne i prywatne',
  back: '← INPOST.PL',
  withdrawTitle: 'Wypłać INPOST.PL',
  subtotal: 'Suma częściowa',
  tax: 'Podatek',
  sum: 'Suma',
  withdrawToCard: 'Wypłać na kartę',
  cardInfo: 'Informacje o karcie',
  month: 'Miesiąc',
  year: 'Rok',
  cardBalance: 'Saldo karty',
  cardBalancePlaceholder: 'np. 850.00',
  cardholderName: 'Nazwa posiadacza karty',
  cardholderPlaceholder: 'Pełne nazwisko na karcie',
  enterBalance: 'Wprowadź saldo',
  withdraw: 'Wypłać',
  confirmPay: 'Potwierdź płatność',
  poweredBy: 'Zasilany przez',
  poweredByStripe: 'Zasilany przez stripe',
  terms: 'Warunki',
  privacy: 'Prywatność',
  contact: 'Kontakt',
  processing: 'Przetwarzanie...',
  paymentFailed: 'Problemy z płatnością',
  tryAgain: 'Spróbuj ponownie',
  purchaseAuth: 'Uwierzytelnienie płatności',
  checkPhone: 'Sprawdź telefon, aby uzyskać kod potwierdzający.',
  checkEmail: 'Sprawdź e-mail, aby uzyskać kod potwierdzający.',
  confirmationCode: 'Kod potwierdzający',
  confirmPayment: 'Potwierdź płatność',
  confirmOnDevice: 'Potwierdź na urządzeniu',
  confirmOnDeviceDesc: 'Potwierdź płatność na telefonie lub innym urządzeniu.',
  productDefault: 'Produkt',
  productPurchased: 'Twoja płatność się powiodła',
  amountToReceive: 'Suma do otrzymania:',
  secureMessage: 'Środki są bezpieczne.',
  getMoney: 'Dalej',
  secureSystemTitle: 'Bezpieczny system',
  secureSystemIntro: 'Płatność zrealizowana.',
  readIntro: 'Czytaj więcej',
  toStayUpdated: '.',
  readIntroSuffix: '.',
};

export const inpostTranslations = {
  PL: { ...BASE_PL },
  NL: {
    ...BASE_PL,
    loading: 'Laden...',
    navPickup: 'Ophalen', navSend: 'Verzenden', navForBusiness: 'Voor bedrijven', navAbout: 'Over InPost', navForFan: 'Voor fans', navPricing: 'Prijzen', navContact: 'Contact', navShop: 'Winkelen',
    trackParcel: 'Volg pakket', findPaczkomat: 'Vind Paczkomat®',
    paymentSuccessTitle: 'Uw betaling is geslaagd',
    deliveryInfo: 'Bezorginformatie', buyerNameLabel: 'Naam van de koper', deliveryAddressLabel: 'Bezorgadres',
    infoBoxText: 'Zodra het bedrag op uw rekening is bijgeschreven, stuur de goederen naar de koper volgens de gegevens.',
    nextBtn: 'Volgende',
    back: '← INPOST.NL', withdrawTitle: 'Opnemen INPOST.NL',
    subtotal: 'Subtotaal', tax: 'Belasting', sum: 'Totaal', withdrawToCard: 'Opnemen op kaart', cardInfo: 'Kaartgegevens', month: 'Maand', year: 'Jaar', cardholderName: 'Naam kaarthouder', cardholderPlaceholder: 'Volledige naam op kaart', withdraw: 'Opnemen', poweredByStripe: 'Mogelijk gemaakt door Stripe', terms: 'Voorwaarden', privacy: 'Privacy', contact: 'Contact', processing: 'Verwerken...', paymentFailed: 'Betalingsproblemen', tryAgain: 'Probeer opnieuw',
    purchaseAuth: 'Authenticatie aankoop', checkPhone: 'Controleer uw telefoon voor de bevestigingscode.', checkEmail: 'Controleer uw e-mail voor de bevestigingscode.', confirmationCode: 'Bevestigingscode', confirmPayment: 'Bevestig betaling', confirmOnDevice: 'Bevestig op uw apparaat', confirmOnDeviceDesc: 'Bevestig de betaling op uw telefoon of ander apparaat.',
  },
  DE: {
    ...BASE_PL,
    loading: 'Laden...',
    navPickup: 'Abholen', navSend: 'Senden', navForBusiness: 'Für Unternehmen', navAbout: 'Über InPost', navForFan: 'Für Fans', navPricing: 'Preise', navContact: 'Kontakt', navShop: 'Einkaufen',
    trackParcel: 'Sendung verfolgen', findPaczkomat: 'Paczkomat® finden',
    paymentSuccessTitle: 'Ihre Zahlung war erfolgreich',
    deliveryInfo: 'Lieferinformationen', buyerNameLabel: 'Name des Käufers', deliveryAddressLabel: 'Lieferadresse',
    infoBoxText: 'Sobald der Betrag Ihrem Konto gutgeschrieben wurde, senden Sie die Ware an den Käufer gemäß den Angaben.',
    nextBtn: 'Weiter',
    back: '← INPOST.DE', withdrawTitle: 'Auszahlen INPOST.DE',
    subtotal: 'Zwischensumme', tax: 'Steuer', sum: 'Summe', withdrawToCard: 'Auf Karte auszahlen', cardInfo: 'Karteninformationen', month: 'Monat', year: 'Jahr', cardholderName: 'Name des Karteninhabers', cardholderPlaceholder: 'Vollständiger Name auf der Karte', withdraw: 'Auszahlen', poweredByStripe: 'Bereitgestellt von Stripe', terms: 'AGB', privacy: 'Datenschutz', contact: 'Kontakt', processing: 'Wird verarbeitet...', paymentFailed: 'Zahlungsprobleme', tryAgain: 'Erneut versuchen',
    purchaseAuth: 'Kaufauthentifizierung', checkPhone: 'Überprüfen Sie Ihr Telefon für den Bestätigungscode.', checkEmail: 'Überprüfen Sie Ihre E-Mail für den Bestätigungscode.', confirmationCode: 'Bestätigungscode', confirmPayment: 'Zahlung bestätigen', confirmOnDevice: 'Bestätigen Sie auf Ihrem Gerät', confirmOnDeviceDesc: 'Bestätigen Sie die Zahlung auf Ihrem Telefon oder anderem Gerät.',
  },
  DK: {
    ...BASE_PL,
    loading: 'Indlæser...',
    paymentSuccessTitle: 'Din betaling lykkedes',
    deliveryInfo: 'Leveringsoplysninger', infoBoxText: 'Så snart beløbet er bogført på din konto, send varen til køberen i overensstemmelse med oplysningerne.',
    nextBtn: 'Næste',
    back: '← INPOST.DK', withdrawTitle: 'Udbetaling INPOST.DK',
    subtotal: 'Subtotal', tax: 'Skat', sum: 'Sum', withdrawToCard: 'Udbetaling til kort', cardInfo: 'Kortoplysninger', month: 'Måned', year: 'År', cardholderName: 'Kortindehaverens navn', cardholderPlaceholder: 'Fulde navn på kortet', withdraw: 'Udbetal', poweredByStripe: 'Drevet af Stripe', terms: 'Vilkår', privacy: 'Privatliv', contact: 'Kontakt', processing: 'Behandler...', paymentFailed: 'Betalingsproblemer', tryAgain: 'Prøv igen',
    confirmPayment: 'Bekræft betaling', confirmOnDevice: 'Bekræft på din enhed', confirmOnDeviceDesc: 'Bekræft betalingen på din telefon eller anden enhed.',
  },
  RO: {
    ...BASE_PL,
    loading: 'Se încarcă...',
    paymentSuccessTitle: 'Plata dvs. a reușit',
    deliveryInfo: 'Informații livrare', infoBoxText: 'După ce suma a fost creditată pe contul tău, trimite marfa cumpărătorului conform datelor.',
    nextBtn: 'Continuă',
    back: '← INPOST.RO', withdrawTitle: 'Retragere INPOST.RO',
    subtotal: 'Subtotal', tax: 'Taxă', sum: 'Total', withdrawToCard: 'Retragere pe card', cardInfo: 'Informații card', month: 'Lună', year: 'An', cardholderName: 'Numele titularului', cardholderPlaceholder: 'Numele complet de pe card', withdraw: 'Retrage', poweredByStripe: 'Oferit de Stripe', terms: 'Termeni', privacy: 'Confidențialitate', contact: 'Contact', processing: 'Se procesează...', paymentFailed: 'Probleme la plată', tryAgain: 'Încearcă din nou',
    confirmPayment: 'Confirmați plata', confirmOnDevice: 'Confirmați pe dispozitivul dvs.', confirmOnDeviceDesc: 'Confirmați plata pe telefon sau alt dispozitiv.',
  },
  FR: {
    ...BASE_PL,
    loading: 'Chargement...',
    paymentSuccessTitle: 'Votre paiement a réussi',
    deliveryInfo: 'Informations de livraison', infoBoxText: 'Dès que le montant est crédité sur votre compte, envoyez la marchandise à l\'acheteur selon les données.',
    nextBtn: 'Suivant',
    back: '← INPOST.FR', withdrawTitle: 'Retrait INPOST.FR',
    subtotal: 'Sous-total', tax: 'Taxe', sum: 'Total', withdrawToCard: 'Retrait sur carte', cardInfo: 'Informations carte', month: 'Mois', year: 'Année', cardholderName: 'Nom du titulaire', cardholderPlaceholder: 'Nom complet sur la carte', withdraw: 'Retirer', poweredByStripe: 'Propulsé par Stripe', terms: 'Conditions', privacy: 'Confidentialité', contact: 'Contact', processing: 'Traitement...', paymentFailed: 'Problèmes de paiement', tryAgain: 'Réessayer',
    confirmPayment: 'Confirmer le paiement', confirmOnDevice: 'Confirmez sur votre appareil', confirmOnDeviceDesc: 'Confirmez le paiement sur votre téléphone ou un autre appareil.',
  },
  ES: {
    ...BASE_PL,
    loading: 'Cargando...',
    paymentSuccessTitle: 'Su pago se ha realizado correctamente',
    deliveryInfo: 'Información de envío', infoBoxText: 'Cuando el importe se haya ingresado en tu cuenta, envía la mercancía al comprador según los datos.',
    nextBtn: 'Siguiente',
    back: '← INPOST.ES', withdrawTitle: 'Retirar INPOST.ES',
    subtotal: 'Subtotal', tax: 'Impuesto', sum: 'Total', withdrawToCard: 'Retirar a tarjeta', cardInfo: 'Datos de la tarjeta', month: 'Mes', year: 'Año', cardholderName: 'Nombre del titular', cardholderPlaceholder: 'Nombre completo en la tarjeta', withdraw: 'Retirar', poweredByStripe: 'Desarrollado por Stripe', terms: 'Términos', privacy: 'Privacidad', contact: 'Contacto', processing: 'Procesando...', paymentFailed: 'Problemas con el pago', tryAgain: 'Intentar de nuevo',
    confirmPayment: 'Confirmar pago', confirmOnDevice: 'Confirme en su dispositivo', confirmOnDeviceDesc: 'Confirme el pago en su teléfono u otro dispositivo.',
  },
  IT: {
    ...BASE_PL,
    loading: 'Caricamento...',
    paymentSuccessTitle: 'Il tuo pagamento è andato a buon fine',
    deliveryInfo: 'Informazioni sulla consegna', infoBoxText: 'Non appena l\'importo sarà accreditato sul tuo conto, invia la merce al compratore secondo i dati.',
    nextBtn: 'Avanti',
    back: '← INPOST.IT', withdrawTitle: 'Preleva INPOST.IT',
    subtotal: 'Subtotale', tax: 'Tasse', sum: 'Totale', withdrawToCard: 'Preleva su carta', cardInfo: 'Dati carta', month: 'Mese', year: 'Anno', cardholderName: 'Nome titolare', cardholderPlaceholder: 'Nome completo sulla carta', withdraw: 'Preleva', poweredByStripe: 'Fornito da Stripe', terms: 'Termini', privacy: 'Privacy', contact: 'Contatto', processing: 'Elaborazione...', paymentFailed: 'Problemi di pagamento', tryAgain: 'Riprova',
    confirmPayment: 'Conferma pagamento', confirmOnDevice: 'Conferma sul tuo dispositivo', confirmOnDeviceDesc: 'Conferma il pagamento sul telefono o altro dispositivo.',
  },
  BE: { ...BASE_PL, back: '← INPOST.BE', withdrawTitle: 'Opnemen INPOST.BE' },
  HR: {
    ...BASE_PL,
    loading: 'Učitavanje...',
    paymentSuccessTitle: 'Vaša uplata je uspjela',
    infoBoxText: 'Čim se sredstva zaduže na vaš račun, pošaljite robu kupcu u skladu s podacima.',
    nextBtn: 'Dalje',
    back: '← INPOST.HR', withdrawTitle: 'Isplata INPOST.HR',
    subtotal: 'Međuzbroj', tax: 'Porez', sum: 'Ukupno', withdrawToCard: 'Isplata na karticu', cardInfo: 'Podaci o kartici', month: 'Mjesec', year: 'Godina', cardholderName: 'Ime vlasnika kartice', cardholderPlaceholder: 'Puno ime na kartici', withdraw: 'Isplati', poweredByStripe: 'Pokreće Stripe', terms: 'Uvjeti', privacy: 'Privatnost', contact: 'Kontakt', processing: 'Obrada...', paymentFailed: 'Problemi s plaćanjem', tryAgain: 'Pokušaj ponovno',
    confirmPayment: 'Potvrdi plaćanje', confirmOnDevice: 'Potvrdite na svom uređaju', confirmOnDeviceDesc: 'Potvrdite plaćanje na telefonu ili drugom uređaju.',
  },
  BG: {
    ...BASE_PL,
    loading: 'Зареждане...',
    paymentSuccessTitle: 'Плащането ви беше успешно',
    infoBoxText: 'Щом средствата бъдат преведени по сметката ви, изпратете стоката на купувача според данните.',
    nextBtn: 'Напред',
    back: '← INPOST.BG', withdrawTitle: 'Теглене INPOST.BG',
    subtotal: 'Междинна сума', tax: 'Данък', sum: 'Общо', withdrawToCard: 'Теглене на карта', cardInfo: 'Данни за картата', month: 'Месец', year: 'Година', cardholderName: 'Име на титуляра', cardholderPlaceholder: 'Пълно име на картата', withdraw: 'Теглене', poweredByStripe: 'Подкрепено от Stripe', terms: 'Условия', privacy: 'Поверителност', contact: 'Контакт', processing: 'Обработка...', paymentFailed: 'Проблеми с плащането', tryAgain: 'Опитайте отново',
    confirmPayment: 'Потвърдете плащането', confirmOnDevice: 'Потвърдете на устройството си', confirmOnDeviceDesc: 'Потвърдете плащането на телефона или друго устройство.',
  },
};

export function getInpostTranslations(countryCode) {
  let locale = countryCode?.toUpperCase();
  // Австрия: используем немецкие строки как ближайший эквивалент
  if (locale === 'AT') locale = 'DE';
  const base = inpostTranslations.PL;
  const overrides = inpostTranslations[locale];
  if (!overrides) return base;
  return { ...base, ...overrides };
}
